import React from 'react';
import cx from 'classnames';
import {UserIcon} from '@heroicons/react/solid';
import {Disclosure} from '@headlessui/react';
import {
  LightbulbIcon, InfoIcon, StoryBookIcon, CaretIcon,
} from './svg';

const CalloutTypes = {
  Tip: {
    text: 'Tip',
    className: 'bg-green-50 border border-green-200 text-green-900',
    icon: <LightbulbIcon width={14} height={20} fill="currentColor" />,
    defaultOpen: true,
  },
  Note: {
    text: 'Note',
    className: 'bg-yellow-50 border border-yellow-200 text-yellow-900',
    icon: <InfoIcon className="h-5 w-5" />,
    defaultOpen: true,
  },
  Summary: {
    text: 'Summary',
    className: 'bg-indigo-50 border border-indigo-200 text-indigo-900',
    icon: <StoryBookIcon width={20} height={20} />,
    defaultOpen: true,
  },
  Example: {
    text: 'Example',
    className: 'bg-blue-50 border border-blue-200 text-blue-900',
    icon: <StoryBookIcon width={20} height={20} />,
    defaultOpen: true,
  },
  SeniorCandidates: {
    text: 'Senior candidates',
    className: 'bg-gray-50 border border-grey-200 text-grey-900',
    icon: <UserIcon width={20} height={20} />,
    defaultOpen: true,
  },
  Hint: {
    text: 'Hint',
    className: 'bg-green-50 border border-green-200 text-green-900',
    defaultOpen: false,
  },
  Challenge: {
    text: 'Challenge',
    className: 'bg-yellow-50 border border-yellow-200 text-yellow-800',
    defaultOpen: true,
  },
};

const Callout = ({
  type = 'Note',
  open: o,
  children,
}) => (
  <Disclosure
    as="div"
    defaultOpen={o !== undefined ? o : CalloutTypes[type]?.defaultOpen}
    className={cx(`
      not-prose
      flex
      flex-col
      mt-6
      md:rounded-lg
      md:shadow-sm
    `, CalloutTypes[type]?.className)}
  >
    {({open}) => (
      <>
        <Disclosure.Button>
          <div className="flex flex-row items-center justify-between py-2 px-6">
            <div className="space-x-2">
              {CalloutTypes[type]?.icon}
              <span className="font-bold text-base">{CalloutTypes[type]?.text}</span>
            </div>
            <CaretIcon
              width={9}
              height={12}
              className={cx(open ? 'rotate-90' : '-rotate-90', 'transform')}
              fill="currentColor"
            />
          </div>
        </Disclosure.Button>
        <Disclosure.Panel className="px-6 -mt-5" unmount={false}>
          {children}
        </Disclosure.Panel>
      </>
    )}
  </Disclosure>
);

export default Callout;
